module.exports = __webpack_public_path__ + "img/4.56f2ffcc.jpg";